import { useMutation } from '@apollo/client';
import { CREATE_PREREQUISIT_SET } from '../../mutations';

export function useCreatePrerequisiteMutation() {
    return useMutation( CREATE_PREREQUISIT_SET );
}
